/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nCurrency.vue?vue&type=template&id=3ef0d4ce&scoped=true"
import script from "./nCurrency.vue?vue&type=script&lang=js"
export * from "./nCurrency.vue?vue&type=script&lang=js"
import style0 from "./nCurrency.vue?vue&type=style&index=0&id=3ef0d4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef0d4ce",
  null
  
)

export default component.exports